export default __webpack_public_path__ + "static/media/Roller Conveyor.1b08d176.jpg";